/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockIcon20Light = forwardRef('TimeClockIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.003 6.505a.5.5 0 0 0-1 0v2.972c0 .662.374 1.268.967 1.565l2.806 1.405a.5.5 0 0 0 .448-.894l-2.806-1.405a.75.75 0 0 1-.415-.671V6.505Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z" })));
});
